import { IncidentsActivityPanelWebComponent } from './component/IncidentsActivityPanelWebComponent';
import { WEB_COMPONENT_INCIDENTS_ACTIVITY_PANEL } from '../../webcomponents.constants';

export { IncidentsActivityPanelWebComponent };

window.customElements.define(WEB_COMPONENT_INCIDENTS_ACTIVITY_PANEL, IncidentsActivityPanelWebComponent);
